import { colors, devices } from '../../config/theme'

const style = {}

style.base = {
  '& .leftCol': {
    width: '100%'
  }
}

style.upcomingVisit = {
  display: 'flex',
  justifyContent: 'space-between',
  color: colors.blue,
  fontSize: '28px !important',
  fontWeight: '500',
  flexDirection: 'row',
  alignItems: 'center'
}

style.base[devices.desktop] = {
  '& h3': {
    maxWidth: '380px',
    fontSize: '13px',
    color: '#959595'
  }
}
style.base[devices.mobile] = {
  '& h3': {
    fontSize: '13px',
    color: '#959595',
    marginTop: '60px',
    paddingBottom: '15px !important',
    '&:first-child': {
      color: colors.black,
      marginTop: '0px'
    }
  }
}

style.upcomingVisit[devices.mobile] = {
  fontSize: '26px !important',
  maxWidth: '240px',
  marginBottom: '40px'
}

style.upcomingVisit[devices.desktop] = {
  '& span': {
    paddingRight: '20px'
  }
}

export default style
